import React, { useCallback } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";

import styled from "@emotion/styled";

import { useAuthStore, useProfileStore } from "@/stores/hooks";

const Container = styled.div`
  width: 1240px;
  margin: 0 auto;
  padding: 10px 0;
`;
const LogoImage = styled.img`
  height: 40px;
`;

const NavLink = styled(Link)`
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  font-weight: bold;
  color: ${({ active }) => (active ? "black" : "rgba(0, 0, 0, 0.5)")};
  display: block;
  padding: 0.5rem 1rem;
`;

const NavLinkBoot = styled(Nav.Link)`
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  font-weight: bold;
`;

const CS_MENU_ITEMS = [
  { name: "DelayedDeliveries", path: "/delayed-deliveries", label: "배송지연내역" },
  { name: "Cses", path: "/cses", label: "CS내역" },
  { name: "SentBackDeliveries", path: "/sent-back-deliveries", label: "반송완료내역" },
  { name: "LostDeliveries", path: "/lost-deliveries", label: "분실파손내역" },
];

const DropdownWrap = styled.div`
  position: relative;

  &:hover .cs-dropdown-menu {
    display: block;
  }
`;

const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 1000;
  padding: 4px 0;
`;

const DropdownItem = styled(Link)`
  display: block;
  padding: 8px 16px;
  font-weight: bold;
  color: ${({ active }) => (active ? "black" : "rgba(0, 0, 0, 0.5)")};
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    color: black;
    text-decoration: none;
  }
`;

export default function NavComponent({ scanner, routeName }) {
  const { ...actions } = useAuthStore();
  const { user: authUser } = useAuthStore().state;
  const { user: profileUser } = useProfileStore().state;
  const canAccessCsCommunication = Boolean(
    authUser?.canAccessCsCommunication ||
      profileUser?.canAccessCsCommunication,
  );

  const signOut = useCallback(() => {
    actions.signOut();
  }, [actions.signOut]);

  return (
    <Container>
      <Navbar>
        <Navbar.Brand href="/deliveries">
          <LogoImage
            alt="두발히어로 로고 이미지"
            src="/assets/images/logo.png"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto" />
          {scanner ? (
            <Nav>
              <NavLink to="/deliveries-for-scanner">
                운송장 출력 전용(스캐너)
              </NavLink>
              <NavLink onClick={signOut}>로그아웃</NavLink>
            </Nav>
          ) : (
            <Nav>
              <NavLink to="/deliveries" active={routeName === "Deliveries"}>
                조회
              </NavLink>
              <NavLink
                to="/deliveries-collected"
                active={routeName === "DeliveriesCollected"}
              >
                회송조회
              </NavLink>
              <NavLink
                to="/deliveries-new"
                active={routeName === "DeliveriesNew"}
              >
                배송접수
              </NavLink>
              {canAccessCsCommunication && (
                <DropdownWrap>
                  <NavLink
                    to="/delayed-deliveries"
                    active={CS_MENU_ITEMS.some((item) => item.name === routeName)}
                  >
                    배송사소통
                  </NavLink>
                  <DropdownMenu className="cs-dropdown-menu">
                    {CS_MENU_ITEMS.map((item) => (
                      <DropdownItem
                        key={item.path}
                        to={item.path}
                        active={routeName === item.name}
                      >
                        {item.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </DropdownWrap>
              )}
              <NavLink to="/profile" active={routeName === "Profile"}>
                내정보
              </NavLink>
              <NavLinkBoot onClick={signOut}>로그아웃</NavLinkBoot>
            </Nav>
          )}
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}
